import React, { Component } from 'react'

import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextFileReader from '../components/BackupFileReader'
import uuid from 'react-uuid'
import { withViewportWidth } from '../utils/withViewportWidth'

class Prompt extends Component {
  constructor(props) {
    super(props)
    this.state = {
      id: props.id || uuid(),
    }
  }

  render() {
    const dialog = (
      <Dialog
        maxWidth='sm'
        fullWidth
        className={this.props.className}
        aria-labelledby='confirmation-dialog-title'
        open={this.props.visible ? this.props.visible : false}
      >
        <DialogTitle
          id={`title_${this.state.id}`}
          sx={{ color: 'text.secondary' }}
        >
          {this.props.title}
        </DialogTitle>
        <DialogContent>
          {this.props.message}

          {this.props.options &&
            this.props.options.map((option, index) => (
              <li key={index}>{option}</li>
            ))}

          {this.props.image && (
            <>
              <img
                src={this.props.image}
                alt='progerar'
                style={{
                  position: 'relative',
                  left: '5px',
                  top: '10px',
                }}
                width={'30px'}
                height={'30px'}
              />
            </>
          )}
          {/* `compact`: sem o vão fixo antes dos botões (opt-in; os outros usos não mudam) */}
          {!this.props.compact && <br></br>}
          {this.props.secondaryMessage && this.props.secondaryMessage}
          {!this.props.compact && <br></br>}
          {this.props.checkbox && (
            <>
              <input
                type='checkbox'
                checked={this.props.checkbox.checked}
                onChange={this.props.checkbox.onChange}
              ></input>{' '}
              {this.props.checkbox.label}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection:
                (this.props.viewportWidth ?? 1024) < 440 ? 'column' : 'row',
              alignItems:
                (this.props.viewportWidth ?? 1024) < 440 ? 'end' : 'center',
              width: '100%',
              padding: '4px 8px',
            }}
          >
            {this.props.leftButton ? (
              <Button
                onClick={this.props.leftButton.onClick}
                disabled={this.props.leftButton.disabled}
                color='primary'
              >
                {this.props.leftButton.label}
              </Button>
            ) : (
              <div />
            )}
            <div
              style={
                (this.props.viewportWidth ?? 1024) < 440 &&
                this.props.leftButton
                  ? {
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'end',
                    }
                  : { display: 'flex', flexDirection: 'row' }
              }
            >
              {this.props.buttons.map((button, index) => (
                <Button
                  key={`button_${this.state.id}_${index}`}
                  autoFocus={button.autoFocus != null ? button.autoFocus : true}
                  onClick={button.onClick}
                  disabled={button.disabled}
                  color='primary'
                  variant={button.variant}
                >
                  {button.file ? (
                    <Button component='label' color='primary'>
                      {button.label}
                      <TextFileReader></TextFileReader>
                    </Button>
                  ) : (
                    button.label
                  )}
                </Button>
              ))}
            </div>
          </div>
        </DialogActions>
      </Dialog>
    )

    return this.props.withContainer ? (
      <Container disableGutters>{dialog}</Container>
    ) : (
      dialog
    )
  }
}

export default withViewportWidth(Prompt)
